import { actions, elements } from '@ecosystem/newron-design-system';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';

import { useOnOutsideClick } from '../tools/outsideclick.hook';

import { useContextTracking } from './contextTracking.hook';
import './display.css';
import { useMobile } from './mobile/mobile.provider';
import { ContextManager } from './manager';

const TITLES = {
  change: 'Change',
  currency_code: 'Currency',
  quantity_type: 'Quantities',
  excludeVat: 'VAT',
};

const { IconButton } = actions;
const { Icon } = elements;
const { MoreHoriz, Check } = Icon.icons;

export const MobileAnalysisGlobalSettings = ({ settings, context }) => {
  const { values } = context.settings;
  const { trackUpdates } = useContextTracking();

  const [expanded, setExpanded] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { isLandscape } = useMobile();

  useOnOutsideClick(containerRef, () => {
    setExpanded(false);
  });

  const onclickMore = () => {
    setExpanded(!expanded);
  };

  const getIsSelected = (name: string, currentValue: string) => {
    return values[name][0].value === currentValue;
  };

  const onSelectOption = (update, metadata) => {
    ContextManager.getInstance().updateSettingsValues(update);
    trackUpdates({ tracking: metadata?.tracking }, update);
  };

  return (
    <div ref={containerRef} className={classNames('static', { 'market-global-settings': expanded })}>
      <IconButton testId="context-more-btn" onClick={onclickMore}>
        <MoreHoriz />
      </IconButton>
      {expanded && (
        <div
          className={classNames(
            'absolute z-50 left-0 mt-2.5 bg-white w-full px-2 py-3 text-default shadow-lg border border-default',
            {
              'settings-h overflow-scroll': isLandscape,
            }
          )}
        >
          {settings.map(setting => (
            <div key={setting.name}>
              <div className="text-sm font-bold">{TITLES[setting.name]}</div>
              {setting.selection.options.map(option => (
                <button
                  key={option.value}
                  className="flex-row items-center gap-x-2 w-full text-md"
                  onClick={() => {
                    const update = { [setting.name]: [option] };
                    onSelectOption(update, setting.selection.metadata);
                  }}
                >
                  <div className="justify-center items-center w-6 h-6 m-2">
                    {getIsSelected(setting.name, option.value) && (
                      <Icon>
                        <Check />
                      </Icon>
                    )}
                  </div>
                  {option.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
